import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19dbc003"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "my-header" }
const _hoisted_2 = { style: {"font-size":"22px"} }
const _hoisted_3 = { class: "customer-statistics-page" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-tip" }, "各位小伙伴，请仔细阅读本次客户联系提醒，及时联系客户", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"text-align":"right","margin-bottom":"10px"} }, null, -1))
const _hoisted_6 = {
  key: 0,
  class: "search-form"
}
const _hoisted_7 = {
  key: 1,
  class: "table-container contLoading"
}
const _hoisted_8 = { style: {"display":"flex","align-items":"center","justify-content":"center","width":"40px","height":"40px","background":"#f5f7fa","border-radius":"50%"} }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "footer" }

import { ref, computed ,shallowRef} from 'vue'
import { ElButton, ElMessage, ElRadioGroup, ElRadioButton } from "element-plus";
import { Picture } from '@element-plus/icons-vue'
import { getListData, downloadData } from '@/service/main/system'
import { ILoadingInstance } from 'element-plus/lib/el-loading/src/loading.type'
import { ElLoading } from 'element-plus'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
interface TabConfig {
  key: string;
  label: string;
  api: string;
  exportApi?: string;
  exportBtn?: boolean;
  exportBtnText?: string;
  formItems: Array<{
    label: string;
    prop: string;
    type: 'input' | 'select' | 'date' | 'dateRange';
    options?: Array<{ label: string; value: string | number }>;
  }>;
  tableColumns: Array<{
    label: string;
    prop: string;
    width?: number;
    showOverflowTooltip?: boolean;
  }>;
}

// 2. 定义 Tab 列表及对应配置

export default /*#__PURE__*/_defineComponent({
  __name: 'tablist',
  emits: ['close'],
  setup(__props, { expose: __expose, emit: __emit }) {

dayjs.locale('zh-cn')

// 1. 定义类型
const tabList = shallowRef<TabConfig[]>([
  {
    key: 'afterSalesDepositOrder',
    label: '售后直播间定金订单客户信息',
    api: '/main/afterSalesLiveQuanzi/queryByConditionWithAuth',
    exportApi: '/main/afterSalesLiveQuanzi/exportAfterSalesDepositOrders',
    exportBtn: true,
    exportBtnText: '导出',
    formItems: [
      { label: '商品名', prop: 'productName', type: 'input' },
      { label: '客户姓名', prop: 'customerName', type: 'input' },
      { label: '微信昵称', prop: 'nickname', type: 'input' },
      { label: '客户unionId', prop: 'unionid', type: 'input' },
      { label: '所属员工', prop: 'empName', type: 'input' },
      {
        label: '签约状态',
        prop: 'signStatus',
        type: 'select',
        options: [
          { label: '未签约', value: 0 },
          { label: '已签约', value: 1 }
        ]
      },
      {
        label: '支付状态',
        prop: 'status',
        type: 'select',
        options: [
          { label: '等待支付', value: 0 },
          { label: '支付成功', value: 10 },
          { label: '已退款', value: 20 },
          { label: '支付关闭', value: 30 },
          { label: '失败（三方订单不存在）', value: 40 },
          { label: '已过期（超过一周未完成支付）', value: 50 }
        ]
      },
    ],
    tableColumns: [
      { label: '客户姓名', prop: 'customerName', width: 100 },
      { label: '微信昵称', prop: 'nickname', width: 100 },
      { label: '头像', prop: 'avatar', width: 80 },
      { label: '客户unionId', prop: 'unionid', width: 150 },
      { label: '直播间名称', prop: 'channelName', width: 120 },
      { label: '商品名', prop: 'productName', width: 150 },
      { label: '支付金额', prop: 'price', width: 100 },
      { label: '签约状态', prop: 'signStatus', width: 100 },
      { label: '所属部门', prop: 'deptName', width: 100 },
      { label: '所属员工', prop: 'empName', width: 100 },
      { label: '下单时间', prop: 'orderCreateTime', width: 150 },
      { label: '支付时间', prop: 'payTime', width: 150 },
      { label: '支付单号', prop: 'orderId', width: 150 },
      { label: '支付状态', prop: 'status', width: 100 },
      { label: '支付渠道', prop: 'channelCode', width: 120 },
      { label: '是否退款', prop: 'isRefund', width: 100 },
      { label: '退款金额', prop: 'refundAmount', width: 100 },
    ],
  },
  {
    key: 'afterSalesSensitiveWordWarning',
    label: '敏感词预警',
    api: '/main/recordAfterSalesSensitiveWordsWarning/getPageWithAuthControl',
    exportApi: '/main/recordAfterSalesSensitiveWordsWarning/exportAfterSalesSensitiveWords',
    exportBtn: true,
    exportBtnText: '导出',
    formItems: [
      { label: '客户姓名', prop: 'custName', type: 'input' },
      { label: '业务员姓名', prop: 'empName', type: 'input' },
      { label: '业务员工作账号', prop: 'empUserId', type: 'input' },
      { label: '所属组别', prop: 'deptName', type: 'input' },
      { label: '命中关键词', prop: 'hitKeywords', type: 'input' },
      { label: '消息时间', prop: 'msgTimeRange', type: 'dateRange' },
    ],
    tableColumns: [
      { label: '主体名称', prop: 'corpName', width: 100 },
      { label: '业务员姓名', prop: 'empName', width: 100 },
      { label: '业务员工作账号', prop: 'empUserId', width: 120 },
      { label: '所属组别', prop: 'deptName', width: 100 },
      { label: '客户姓名', prop: 'custName', width: 100 },
      { label: '头像', prop: 'avatar', width: 120 },
      { label: '消息类型', prop: 'msgType', width: 100 },
      { label: '消息内容', prop: 'msgContent', width: 200, showOverflowTooltip: true },
      { label: '消息时间', prop: 'msgTime', width: 150 },
      { label: '命中关键词', prop: 'hitKeywords', width: 120 },
      { label: '风险等级', prop: 'maxRiskLevel', width: 100 },
    ],
  },
  {
    key: 'afterSalesAccountSendCheck',
    label: '当天未发送软件账号密码',
    api: '/main/afterSalesAccountSendCheck/query',
    exportApi: '/main/afterSalesAccountSendCheck/export',
    exportBtn: true,
    exportBtnText: '导出',
    formItems: [
      { label: '客户昵称', prop: 'custName', type: 'input' },
      { label: '所属业务员', prop: 'empName', type: 'input' },
      { label: '业务企微号', prop: 'empUserId', type: 'input' },
      { label: '所属组长', prop: 'leaderName', type: 'input' },
    ],
    tableColumns: [
      { label: '检查日期', prop: 'checkDate', width: 110 },
      { label: '企微主体', prop: 'corpName', width: 120 },
      { label: '客户昵称', prop: 'custName', width: 120 },
      { label: '客户头像', prop: 'avatar', width: 90 },
      { label: '所属业务员', prop: 'empName', width: 110 },
      { label: '业务企微号', prop: 'empUserId', width: 140 },
      { label: '所属组长', prop: 'leaderName', width: 110 },
      { label: '进入售后主体时间', prop: 'enteredAt', width: 160 },
    ],
  },
  {
    key: 'afterSalesStopLossCustomer',
    label: '止损客户是否通话五分钟以上',
    api: '/shData/getStopLossData',
    exportApi: '/shData/exportStopLossData',
    exportBtn: true,
    exportBtnText: '导出',
    formItems: [
      { label: '主体', prop: 'corpName', type: 'input' },
      { label: '企微账号', prop: 'empId', type: 'input' },
      { label: '组长名称', prop: 'groupName', type: 'input' },
      { label: '客户昵称', prop: 'nickName', type: 'input' },
      { label: '客户unionId', prop: 'unionId', type: 'input' },
      { label: '助理名称', prop: 'usedBy', type: 'input' },
    ],
    tableColumns: [
      { label: '主体', prop: 'corpName', width: 120 },
      { label: '企微账号', prop: 'empId', width: 140 },
      { label: '组长名称', prop: 'groupName', width: 110 },
      { label: '助理名称', prop: 'usedBy', width: 110 },
      { label: '头像', prop: 'avatar', width: 80 },
      { label: '客户昵称', prop: 'nickName', width: 120 }, 
      { label: '客户unionId', prop: 'unionId', width: 180 },
      { label: '消息内容', prop: 'content', width: 240, showOverflowTooltip: true },
      { label: '消息时间', prop: 'msgTime', width: 160 },
    ],
  },
  {
    key: 'afterSalesWorkMessageCheck',
    label: '社区/企微消息发送跟踪',
    api: '/main/afterSalesWorkMessageCheck/query',
    exportApi: '/main/afterSalesWorkMessageCheck/export',
    exportBtn: true,
    exportBtnText: '导出',
    formItems: [
      {
        label: '检查渠道',
        prop: 'sourceType',
        type: 'select',
        options: [
          { label: '企微', value: 'WECHAT_WORK' },
          { label: '软件社区', value: 'SOFTWARE_COMMUNITY' }
        ]
      },
      {
        label: '未发项目',
        prop: 'ruleCode',
        type: 'select',
        options: [
          { label: '课程文案-早', value: 'COURSE_MORNING' },
          { label: '课程文案-午', value: 'COURSE_NOON' },
          { label: '课程文案-晚', value: 'COURSE_EVENING' },
          { label: '早安问候', value: 'GOOD_MORNING' },
          { label: '操作策略', value: 'OPERATION_STRATEGY' }
        ]
      },
      {
        label: '检查结果',
        prop: 'resultType',
        type: 'select',
        options: [
          { label: '未发送', value: 'NOT_SENT' },
          { label: '超时发送', value: 'TIMEOUT_SENT' }
        ]
      },
      { label: '客户昵称/社区名称', prop: 'custName', type: 'input' },
      { label: '助理/社区负责人', prop: 'empName', type: 'input' },
      { label: '助理企微号/社区负责人ID', prop: 'empUserId', type: 'input' },
      { label: '所属组/社区名称', prop: 'groupName', type: 'input' },
      { label: '组长/负责人', prop: 'leaderName', type: 'input' },
    ],
    tableColumns: [
      { label: '检查日期', prop: 'checkDate', width: 110 },
      { label: '检查渠道', prop: 'checkChannel', width: 120 },
      { label: '未发项目', prop: 'missingItem', width: 130 },
      { label: '未发时间段', prop: 'missingPeriod', width: 110 },
      { label: '要求发送时间', prop: 'requiredSendTime', width: 130 },
      { label: '头像', prop: 'avatar', width: 80 },
      { label: '客户/社区名称', prop: 'custName', width: 120 },
      { label: '业务员', prop: 'empName', width: 110 },
      { label: '检查结果', prop: 'resultName', width: 110 },
    ],
  },
]);

// 3. 响应式数据
const activeTab = ref<string>(tabList.value[0].key);
const tableData = ref<any[]>([]);
const currentForm = ref<Record<string, any>>({});

// 4. 计算属性：获取当前激活 Tab 的配置
const currentTabConfig = computed(() => {
  return tabList.value.find((tab) => tab.key === activeTab.value);
});

// 字典数据配置
const dictOptions = {
  signStatus: [
    { value: 0, label: '未签约' },
    { value: 1, label: '已签约' }
  ],
  status: [
    { value: 0, label: '等待支付' },
    { value: 10, label: '支付成功' },
    { value: 20, label: '已退款' },
    { value: 30, label: '支付关闭' },
    { value: 40, label: '失败（三方订单不存在）' },
    { value: 50, label: '已过期（超过一周未完成支付）' }
  ],
  channelCode: [
    { value: 'wallet', label: '钱包' },
    { value: 'mock', label: '模拟支付' },
    { value: 'alipay_qr', label: '支付宝扫码支付' },
    { value: 'alipay_bar', label: '支付宝条码支付' },
    { value: 'alipay_app', label: '支付宝 App 支付' },
    { value: 'alipay_wap', label: '支付宝 Wap 网站支付' },
    { value: 'alipay_pc', label: '支付宝 PC 网站支付' },
    { value: 'wx_bar', label: '微信条码支付' },
    { value: 'wx_native', label: '微信扫码支付' },
    { value: 'wx_app', label: '微信 App 支付' },
    { value: 'wx_lite', label: '微信小程序支付' },
    { value: 'wx_pub', label: '微信公众号支付' },
    { value: 'wx_wap', label: '微信 Wap 网站支付' }
  ]
}

// 字典转义方法
const getDictName = (dictType: string, value: any) => {
  const options = dictOptions[dictType as keyof typeof dictOptions]
  if (!options || value === null || value === undefined) {
    return value || ''
  }
  const item = options.find((opt) => opt.value === value)
  return item ? item.label : value
}

const formatCustomerNickname = (value: any) => {
  if (value === null || value === undefined) return ''

  return String(value).replace(/(^|\D)(1[3-9]\d{9})(?!\d)/g, (_matched, prefix, phone) => {
    return `${prefix}${phone.slice(0, 7)}****`
  })
}

const page = ref({
  pageNo: 1,
  pageSize: 10,
  total: 0
})

let loadingInstance: ILoadingInstance = {} as ILoadingInstance

// Tab 切换时重置表单
const handleTabChange = () => {
  resetForm();
};

// 重置表单
const resetForm = () => {
  if (!currentTabConfig.value) return;
  currentForm.value = currentTabConfig.value.formItems.reduce((obj, item) => {
    obj[item.prop] = '';
    return obj;
  }, {} as Record<string, any>);

  // 如果是敏感词预警页面，初始化消息时间为查询日期前一天的时间段
  if (currentTabConfig.value.key === 'afterSalesSensitiveWordWarning' && currentRow.value?.date) {
    const queryDate = dayjs(currentRow.value.date);
    const previousDate = queryDate.subtract(1, 'day');
    const dateStr = previousDate.format('YYYY-MM-DD');
    currentForm.value.msgTimeRange = [
      `${dateStr} 00:00:00`,
      `${dateStr} 23:59:59`
    ];
  }

  page.value.pageNo = 1
  loadTableData();
};

// 禁用消息时间选择器的日期
const disabledMsgTime = (time: Date) => {
  if (!currentRow.value?.date) return false;
  const queryDate = dayjs(currentRow.value.date);
  const previousDate = queryDate.subtract(1, 'day');
  const currentTime = dayjs(time);
  // 只允许选择查询日期前一天
  return !currentTime.isSame(previousDate, 'day');
};

// 查询方法
const handleSearch = () => {
  console.log('查询条件：', currentForm.value, 'Tab：', activeTab.value);
  page.value.pageNo = 1
  loadTableData();
};

const handleSizeChange = (pageSize: number) => {
  page.value.pageSize = pageSize
  loadTableData()
}

const handleCurrentChange = (pageNo: number) => {
  page.value.pageNo = pageNo
  loadTableData()
}

// 导出功能
const handleExport = async () => {
  if (!currentTabConfig.value) return;

  if (!currentTabConfig.value.exportApi) {
    ElMessage.warning('该Tab暂未配置导出接口');
    return;
  }

  let loadingInstance: any = null;
  try {
    loadingInstance = ElLoading.service({
      lock: true,
      text: '数据导出中...',
      background: 'rgba(0, 0, 0, 0.7)'
    });

    let params: any = {
      sysDate: currentRow.value.date
    };

    // 根据后端接口添加对应的查询参数
    if (currentTabConfig.value.key === 'afterSalesDepositOrder') {
      if (currentForm.value.productName) {
        params.productName = currentForm.value.productName;
      }
      if (currentForm.value.customerName) {
        params.customerName = currentForm.value.customerName;
      }
      if (currentForm.value.nickname) {
        params.nickname = currentForm.value.nickname;
      }
      if (currentForm.value.unionid) {
        params.unionid = currentForm.value.unionid;
      }
      if (currentForm.value.empName) {
        params.empName = currentForm.value.empName;
      }
      if (currentForm.value.deptName) {
        params.deptName = currentForm.value.deptName;
      }
      if (currentForm.value.signStatus !== '' && currentForm.value.signStatus !== undefined && currentForm.value.signStatus !== null) {
        params.signStatus = currentForm.value.signStatus;
      }
      if (currentForm.value.status !== '' && currentForm.value.status !== undefined && currentForm.value.status !== null) {
        params.status = currentForm.value.status;
      }
      if (currentForm.value.channelCode) {
        params.channelCode = currentForm.value.channelCode;
      }
      if (currentForm.value.isRefund) {
        params.isRefund = currentForm.value.isRefund;
      }
      if (currentForm.value.merchantOrderNo) {
        params.merchantOrderNo = currentForm.value.merchantOrderNo;
      }
      if (currentForm.value.channelOrderNo) {
        params.channelOrderNo = currentForm.value.channelOrderNo;
      }
      if (currentForm.value.orderId) {
        params.orderId = currentForm.value.orderId;
      }
    } else if (currentTabConfig.value.key === 'afterSalesSensitiveWordWarning') {
      // 敏感词预警
      if (currentForm.value.custName) {
        params.custName = currentForm.value.custName;
      }
      if (currentForm.value.empName) {
        params.empName = currentForm.value.empName;
      }
      if (currentForm.value.empUserId) {
        params.empUserId = currentForm.value.empUserId;
      }
      if (currentForm.value.deptName) {
        params.deptName = currentForm.value.deptName;
      }
      if (currentForm.value.hitKeywords) {
        params.hitKeywords = currentForm.value.hitKeywords;
      }
      if (currentForm.value.msgTimeStart) {
        params.msgTimeStart = currentForm.value.msgTimeStart;
      }
      if (currentForm.value.msgTimeEnd) {
        params.msgTimeEnd = currentForm.value.msgTimeEnd;
      }
    } else if (currentTabConfig.value.key === 'afterSalesAccountSendCheck') {
      params.checkDate = currentRow.value.date;
      delete params.sysDate;
      ['custName', 'empName', 'empUserId', 'groupName', 'leaderName'].forEach((key) => {
        if (currentForm.value[key]) {
          params[key] = currentForm.value[key];
        }
      });
    } else if (currentTabConfig.value.key === 'afterSalesStopLossCustomer') {
      params.checkDate = currentRow.value.date;
      delete params.sysDate;
      ['corpId', 'empId', 'groupName', 'nickName', 'unionId', 'usedBy'].forEach((key) => {
        if (currentForm.value[key]) {
          params[key] = currentForm.value[key];
        }
      });
    } else if (currentTabConfig.value.key === 'afterSalesWorkMessageCheck') {
      params.checkDate = currentRow.value.date;
      delete params.sysDate;
      ['sourceType', 'ruleCode', 'resultType', 'custName', 'empName', 'empUserId', 'groupName', 'leaderName'].forEach((key) => {
        if (currentForm.value[key]) {
          params[key] = currentForm.value[key];
        }
      });
    }

    console.log('导出接口:', currentTabConfig.value.exportApi);
    console.log('导出参数:', params);

    // 使用 GET 请求调用后端导出接口
    const res = await downloadData(
      currentTabConfig.value.exportApi,
      params,
      'blob'
    );

    console.log('导出接口返回:', res);
    console.log('返回数据类型:', typeof res);
    console.log('是否为Blob:', res instanceof Blob);

    // 检查返回的是否是文件流
    if (res instanceof Blob) {
      const blob = new Blob([res], {
        type: 'application/octet-stream'
      });

      const down = document.createElement('a');
      const fileName = `${currentTabConfig.value.label}_${currentRow.value.date}.xlsx`;
      down.download = fileName;
      down.style.display = 'none';
      down.href = URL.createObjectURL(blob);
      document.body.appendChild(down);
      down.click();
      URL.revokeObjectURL(down.href);
      document.body.removeChild(down);

      ElMessage.success('导出成功');
    } else {
      console.warn('后端返回的不是文件流，返回内容:', res);
      ElMessage.warning('导出失败，请检查后端接口');
    }
  } catch (error) {
    console.error('导出失败:', error);
    ElMessage.error('导出失败，请重试');
  } finally {
    if (loadingInstance && typeof loadingInstance.close === 'function') {
      loadingInstance.close();
    }
  }
};

const emit = __emit;

function closePop() {
  dialogVisible.value = false
  emit('close')
}

// 加载表格数据
const loadTableData = async () => {
  if (!currentTabConfig.value?.api) return;

  if (document.querySelector('.contLoading')) {
    if (loadingInstance && typeof loadingInstance.close === 'function') {
      loadingInstance.close()
    }
    loadingInstance = ElLoading.service({
      target: '.contLoading',
      text: '加载中....',
      spinner: 'el-icon-loading',
      background: 'rgba(255, 255, 255, 0.8)',
      fullscreen: false
    })
  }

  try {
    let obj = {
      pageNo: page.value.pageNo,
      pageSize: page.value.pageSize,
      sysDate: currentRow.value.date
    }
    let params = { ...currentForm.value, ...obj }

    if (['afterSalesAccountSendCheck', 'afterSalesStopLossCustomer', 'afterSalesWorkMessageCheck'].includes(currentTabConfig.value.key)) {
      params.checkDate = currentRow.value.date
      delete params.sysDate
    }

    // 处理消息时间范围参数
    if (currentForm.value.msgTimeRange && currentForm.value.msgTimeRange.length === 2) {
      params.msgTimeStart = currentForm.value.msgTimeRange[0]
      params.msgTimeEnd = currentForm.value.msgTimeRange[1]
      delete params.msgTimeRange
    }

    const res = await getListData(currentTabConfig.value.api, params)
    if (res) {
      const result = res?.data && (res.data.records || res.data.list) ? res.data : res
      tableData.value = result.records ? result.records : result?.list ? result.list : []
      page.value.total = Number(result.total || 0)
    }
  } catch (error) {
    tableData.value = []
  } finally {
    if (loadingInstance && typeof loadingInstance.close === 'function') {
      loadingInstance.close()
    }
  }
};

// 弹窗相关数据
const dialogVisible = ref(false)
const currentRow = ref<any>(null)
const title = ref('')

/** 打开弹窗 */
const open = async (row: any) => {
  dialogVisible.value = true
  currentRow.value = row
  title.value = currentRow.value.date + '售后通知记录'
  resetForm();
}

__expose({ open })

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogVisible.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialogVisible).value = $event)),
    fullscreen: true,
    "show-close": false
  }, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(title.value), 1),
        _createVNode(_unref(ElButton), {
          type: "danger",
          icon: "el-icon-close",
          size: "small",
          onClick: closePop,
          style: {"position":"absolute","top":"0","right":"10px"}
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 关闭 ")
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createVNode(_unref(ElRadioGroup), {
          modelValue: activeTab.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeTab).value = $event)),
          fill: "#409eff",
          onChange: handleTabChange
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabList.value, (tab) => {
              return (_openBlock(), _createBlock(_unref(ElRadioButton), {
                key: tab.key,
                label: tab.key
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(tab.label), 1)
                ]),
                _: 2
              }, 1032, ["label"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"]),
        (currentTabConfig.value?.formItems?.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_el_form, {
                model: currentForm.value,
                inline: "",
                onSubmit: _withModifiers(handleSearch, ["prevent"]),
                class: "mb-4"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentTabConfig.value.formItems, (formItem) => {
                    return (_openBlock(), _createBlock(_component_el_form_item, {
                      key: formItem.prop,
                      label: formItem.label
                    }, {
                      default: _withCtx(() => [
                        (formItem.type === 'input')
                          ? (_openBlock(), _createBlock(_component_el_input, {
                              key: 0,
                              modelValue: currentForm.value[formItem.prop],
                              "onUpdate:modelValue": ($event: any) => ((currentForm.value[formItem.prop]) = $event),
                              placeholder: `请输入${formItem.label}`,
                              clearable: ""
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"]))
                          : (formItem.type === 'select')
                            ? (_openBlock(), _createBlock(_component_el_select, {
                                key: 1,
                                modelValue: currentForm.value[formItem.prop],
                                "onUpdate:modelValue": ($event: any) => ((currentForm.value[formItem.prop]) = $event),
                                placeholder: `请选择${formItem.label}`,
                                clearable: ""
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formItem.options || [], (option) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: option.value,
                                      label: option.label,
                                      value: option.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder"]))
                            : (formItem.type === 'date')
                              ? (_openBlock(), _createBlock(_component_el_date_picker, {
                                  key: 2,
                                  modelValue: currentForm.value[formItem.prop],
                                  "onUpdate:modelValue": ($event: any) => ((currentForm.value[formItem.prop]) = $event),
                                  type: "date",
                                  placeholder: `请选择${formItem.label}`,
                                  clearable: ""
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"]))
                              : (formItem.type === 'dateRange')
                                ? (_openBlock(), _createBlock(_component_el_date_picker, {
                                    key: 3,
                                    modelValue: currentForm.value[formItem.prop],
                                    "onUpdate:modelValue": ($event: any) => ((currentForm.value[formItem.prop]) = $event),
                                    type: "daterange",
                                    "range-separator": "至",
                                    "start-placeholder": "开始时间",
                                    "end-placeholder": "结束时间",
                                    format: "YYYY-MM-DD HH:mm:ss",
                                    "value-format": "YYYY-MM-DD HH:mm:ss",
                                    "disabled-date": currentTabConfig.value?.key === 'afterSalesSensitiveWordWarning' ? disabledMsgTime : undefined,
                                    clearable: ""
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled-date"]))
                                : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1032, ["label"]))
                  }), 128)),
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ElButton), {
                        type: "primary",
                        onClick: handleSearch
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("查询")
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(ElButton), { onClick: resetForm }, {
                        default: _withCtx(() => [
                          _createTextVNode("重置")
                        ]),
                        _: 1
                      }),
                      (currentTabConfig.value?.exportBtn)
                        ? (_openBlock(), _createBlock(_unref(ElButton), {
                            key: 0,
                            type: "success",
                            onClick: handleExport
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(currentTabConfig.value.exportBtnText || '导出'), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]))
          : _createCommentVNode("", true),
        (currentTabConfig.value?.tableColumns?.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_el_table, {
                data: tableData.value,
                border: "",
                stripe: "",
                style: {"width":"100%"},
                "max-height": "500",
                columns: currentTabConfig.value.tableColumns
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentTabConfig.value.tableColumns, (column) => {
                    return (_openBlock(), _createBlock(_component_el_table_column, {
                      key: column.prop,
                      prop: column.prop,
                      label: column.label,
                      "min-width": column.width,
                      "show-overflow-tooltip": column.showOverflowTooltip
                    }, _createSlots({ _: 2 }, [
                      (column.prop === 'signStatus')
                        ? {
                            name: "default",
                            fn: _withCtx((scope) => [
                              _createElementVNode("span", null, _toDisplayString(getDictName('signStatus', scope.row.signStatus)), 1)
                            ]),
                            key: "0"
                          }
                        : undefined,
                      (column.prop === 'status')
                        ? {
                            name: "default",
                            fn: _withCtx((scope) => [
                              _createElementVNode("span", null, _toDisplayString(getDictName('status', scope.row.status)), 1)
                            ]),
                            key: "1"
                          }
                        : undefined,
                      (column.prop === 'channelCode')
                        ? {
                            name: "default",
                            fn: _withCtx((scope) => [
                              _createElementVNode("span", null, _toDisplayString(getDictName('channelCode', scope.row.channelCode)), 1)
                            ]),
                            key: "2"
                          }
                        : undefined,
                      (column.prop === 'price')
                        ? {
                            name: "default",
                            fn: _withCtx((scope) => [
                              _createElementVNode("span", null, "￥" + _toDisplayString(parseFloat((scope.row.price / 100).toFixed(2))), 1)
                            ]),
                            key: "3"
                          }
                        : undefined,
                      (column.prop === 'refundAmount')
                        ? {
                            name: "default",
                            fn: _withCtx((scope) => [
                              _createElementVNode("span", null, "￥" + _toDisplayString(parseFloat((scope.row.refundAmount / 100).toFixed(2))), 1)
                            ]),
                            key: "4"
                          }
                        : undefined,
                      (['customerName', 'nickname', 'nickName', 'custName'].includes(column.prop))
                        ? {
                            name: "default",
                            fn: _withCtx((scope) => [
                              _createElementVNode("span", null, _toDisplayString(formatCustomerNickname(scope.row[column.prop])), 1)
                            ]),
                            key: "5"
                          }
                        : undefined,
                      (column.prop === 'avatar')
                        ? {
                            name: "default",
                            fn: _withCtx((scope) => [
                              (scope.row.avatar)
                                ? (_openBlock(), _createBlock(_component_el_image, {
                                    key: 0,
                                    src: scope.row.avatar,
                                    "preview-src-list": [scope.row.avatar],
                                    fit: "cover",
                                    style: {"width":"40px","height":"40px","border-radius":"50%","cursor":"pointer"}
                                  }, {
                                    error: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_8, [
                                        _createVNode(_component_el_icon, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(Picture))
                                          ]),
                                          _: 1
                                        })
                                      ])
                                    ]),
                                    _: 2
                                  }, 1032, ["src", "preview-src-list"]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_9, "-"))
                            ]),
                            key: "6"
                          }
                        : undefined,
                      (column.prop === 'empUserId')
                        ? {
                            name: "default",
                            fn: _withCtx((scope) => [
                              (scope.row.groupName && currentTabConfig.value?.key !== 'afterSalesAccountSendCheck')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(scope.row.empUserId) + "(" + _toDisplayString(scope.row.groupName) + ")", 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(scope.row.empUserId), 1))
                            ]),
                            key: "7"
                          }
                        : undefined
                    ]), 1032, ["prop", "label", "min-width", "show-overflow-tooltip"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["data", "columns"]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_el_pagination, {
                  "current-page": page.value.pageNo,
                  "page-sizes": [10, 20, 30, 40, 100],
                  "page-size": page.value.pageSize,
                  layout: "total, prev, pager, next, jumper",
                  total: page.value.total,
                  onSizeChange: handleSizeChange,
                  onCurrentChange: handleCurrentChange
                }, null, 8, ["current-page", "page-size", "total"])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})